import { render, staticRenderFns } from "./ExpandedViewTiers.vue?vue&type=template&id=3454e881&scoped=true&"
import script from "./ExpandedViewTiers.vue?vue&type=script&lang=ts&"
export * from "./ExpandedViewTiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454e881",
  null
  
)

export default component.exports